// extracted by mini-css-extract-plugin
export default {"container":"Info_container__mvzTP","list":"Info_list__rCrB3"};